import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';

@NgModule({
  declarations: [],
  imports: [
    NzLayoutModule,
    NzMenuModule,
    CommonModule,
    NzButtonModule,
    NzSwitchModule,
    NzInputModule,
    NzCheckboxModule,
    NzSelectModule,
    NzToolTipModule,
    NzDatePickerModule,
    NzDropDownModule,
  ],
  exports: [
    NzLayoutModule,
    NzMenuModule,
    NzButtonModule,
    NzSwitchModule,
    NzInputModule,
    NzCheckboxModule,
    NzSelectModule,
    NzToolTipModule,
    NzDatePickerModule,
    NzDropDownModule,
  ]
})
export class NzShareModule { }
